import { render, staticRenderFns } from "./PractitionerIntern.vue?vue&type=template&id=adf90cea&scoped=true"
import script from "./PractitionerIntern.vue?vue&type=script&lang=js"
export * from "./PractitionerIntern.vue?vue&type=script&lang=js"
import style0 from "./PractitionerIntern.vue?vue&type=style&index=0&id=adf90cea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf90cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adf90cea')) {
      api.createRecord('adf90cea', component.options)
    } else {
      api.reload('adf90cea', component.options)
    }
    module.hot.accept("./PractitionerIntern.vue?vue&type=template&id=adf90cea&scoped=true", function () {
      api.rerender('adf90cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/practitionerIntern/PractitionerIntern.vue"
export default component.exports